import { AGENT_HUB_ADMIN_BASE_PATH } from '@lumapps/agent-hub/constants';
import { Route, AppId, createEntityManagementRoutes } from '@lumapps/router';

import type { Agent } from './types';

const { baseRoute, createRoute, editRoute, getEditRoute, getCreateRoute } = createEntityManagementRoutes({
    /** Temporary url as for now the page will be for all agents */
    slug: `${AGENT_HUB_ADMIN_BASE_PATH}/agents`,
    id: 'agent-hub-agents',
    appId: AppId.backOffice,
});

export const getAgentsEditRoute = (agentId: Agent['id'], query?: Route['query']): Route =>
    getEditRoute(agentId, undefined, query);

export {
    baseRoute as agentsBaseAdminRoute,
    editRoute as agentsEditAdminRoute,
    createRoute as agentsCreateAdminRoute,
    getCreateRoute as getAgentsCreateRoute,
};
